import React, {Component} from 'react';
import {forwardRef} from 'react';
import VIDABOO_CONSTANTS from '../../../config/consts';

import expertHomeService from '../../../services/expertHomeService';

export const ChatbotContext = React.createContext();

class ChatbotContextProvider extends Component {
  constructor() {
    super();
    this.state = {
      // default value of null means data is not updated by API call yet, otherwise there should be appropriate value like [], {}, [some data] ...
      kbResourceDtos: null,
      brainDto: null,
      kbTrainingStatus: VIDABOO_CONSTANTS.KB_TRAINING_STATUSES.PENDING_TRAINING,
      crawlStatus: null,
    };
  }

  setKbResourceDtos = (kbResourceDtos) => {
    this.setState({kbResourceDtos});
  };

  addOrUpdateKbResourceDtos = (kbResourceDtos) => {
    // todo 1720 : move this logic to service
    let tempKbResourceDtos = this.state.kbResourceDtos
      ? [...this.state.kbResourceDtos]
      : [];
    kbResourceDtos.forEach((kbResourceDto) => {
      const kbrDtoIdx = tempKbResourceDtos.findIndex(
        (kbrDto) => kbrDto.kbResourceId === kbResourceDto.kbResourceId,
      );
      if (kbrDtoIdx !== -1) {
        //update
        tempKbResourceDtos[kbrDtoIdx] = kbResourceDto;
      } else {
        //add
        tempKbResourceDtos.push(kbResourceDto);
      }
    });
    const kbTrainingStatus = tempKbResourceDtos.length
      ? expertHomeService.getKbTrainingStatus(
          VIDABOO_CONSTANTS.KB_TRAINING_STATUSES.PENDING_TRAINING,
          tempKbResourceDtos,
          this.state.brainDto,
        )
      : this.state.kbTrainingStatus;
    this.setState({
      kbResourceDtos: tempKbResourceDtos,
      kbTrainingStatus,
    });
  };

  deleteKbResourceDtos = (kbResourceDtos) => {
    // todo 1720 : move this logic to service
    let tempKbResourceDtos = this.state.kbResourceDtos
      ? [...this.state.kbResourceDtos]
      : [];
    kbResourceDtos.forEach((kbResourceDto) => {
      const kbrDtoIdx = tempKbResourceDtos.findIndex(
        (kbrDto) => kbrDto.kbResourceId === kbResourceDto.kbResourceId,
      );
      if (kbrDtoIdx !== -1) {
        if (
          ![
            VIDABOO_CONSTANTS.KBR_STATUSES.INIT,
            // VIDABOO_CONSTANTS.KBR_STATUSES.PENDING_DELETION,
            // VIDABOO_CONSTANTS.KBR_STATUSES.PENDING_TRAINING,
            // VIDABOO_CONSTANTS.KBR_STATUSES.UPLOADING,
          ].includes(tempKbResourceDtos[kbrDtoIdx].status)
        ) {
          tempKbResourceDtos[kbrDtoIdx] = kbResourceDto;
        } else {
          tempKbResourceDtos.splice(kbrDtoIdx, 1);
        }
      }
    });
    const kbTrainingStatus = tempKbResourceDtos.length
      ? expertHomeService.getKbTrainingStatus(
          VIDABOO_CONSTANTS.KB_TRAINING_STATUSES.PENDING_TRAINING,
          tempKbResourceDtos,
          this.state.brainDto,
        )
      : this.state.kbTrainingStatus;
    this.setState({
      kbResourceDtos: tempKbResourceDtos,
      kbTrainingStatus,
    });
  };

  setBrainDto = (brainDto) => {
    this.setState({brainDto});
  };

  setKbTrainingStatus = (kbTrainingStatus) => {
    this.setState({kbTrainingStatus});
  };

  setCrawlStatus = (crawlStatus) => {
    this.setState({crawlStatus});
  };

  resetChatbotContext = () => {
    this.setState({
      kbResourceDtos: null,
      brainDto: null,
      kbTrainingStatus: VIDABOO_CONSTANTS.KB_TRAINING_STATUSES.PENDING_TRAINING,
      crawlStatus: null,
    });
  };

  render() {
    const {brainDto, crawlStatus, kbResourceDtos, kbTrainingStatus} =
      this.state;
    const {
      addOrUpdateKbResourceDtos,
      deleteKbResourceDtos,
      resetChatbotContext,
      setBrainDto,
      setCrawlStatus,
      setKbResourceDtos,
      setKbTrainingStatus,
    } = this;

    return (
      <ChatbotContext.Provider
        value={{
          brainDto,
          crawlStatus,
          kbResourceDtos,
          kbTrainingStatus,
          addOrUpdateKbResourceDtos,
          deleteKbResourceDtos,
          resetChatbotContext,
          setBrainDto,
          setCrawlStatus,
          setKbResourceDtos,
          setKbTrainingStatus,
        }}>
        {this.props.children}
      </ChatbotContext.Provider>
    );
  }
}

export const withChatbotContext = (Component) =>
  //eslint-disable-next-line react/display-name
  forwardRef((props, ref) => (
    <ChatbotContext.Consumer>
      {(context) => <Component chatbotContext={context} {...props} ref={ref} />}
    </ChatbotContext.Consumer>
  ));

export default ChatbotContextProvider;
